module.exports = "https://web-assets.ifttt.com/packs/media/layout/edit-transparent-7e8b135c.svg";